import { useEffect, useState } from 'react';
import { useLanguage } from '../../utils/language';
import { errorTypes } from '../common/FileUpload/constants';
import fireNotification from '../../utils/fireNotification';

const useUploaderState = ({ initAttachment }) => {
  const [fileUploaderState, setFileUploaderState] = useState({
    isUploading: false,
    selectedFileType: null,
    uploadError: null,
  });

  const [attachment, setAttachment] = useState(initAttachment);
  const { langCode } = useLanguage();

  useEffect(
    () => {
      const { uploadError, selectedFileType } = fileUploaderState;
      if (
        uploadError &&
        uploadError.errorType === errorTypes.conversionError &&
        attachment &&
        selectedFileType === 'DOCUMENT'
      ) {
        return;
      }
      if (uploadError) {
        fireNotification(uploadError.errorType, langCode, uploadError.message);
      }
    },
    [fileUploaderState.uploadError],
  );

  return {
    ...fileUploaderState,
    setFileUploaderState,
    attachment,
    setAttachment,
  };
};

export default useUploaderState;
